import { put, call, takeLatest, select, takeEvery } from 'redux-saga/effects';
import { showErrorModal } from '../../../actions/uiActions';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import {
  getInsuredAccessApiUrl,
  getInsuredPolicyDetailApiUrl,
  getInsuredPolicyListApiUrl,
} from '../selectors/insuredAccessSelector';
import {
  FETCH_INSURED_POLICY_LIST,
  FETCH_INSURED_POLICY_LIST_SUCCESS,
  FETCH_INSURED_POLICY_LIST_FAILURE,
  UPDATE_INSURED_ACCESS,
  UPDATE_INSURED_ACCESS_SUCCESS,
  UPDATE_INSURED_ACCESS_FAILURE,
  FETCH_INSURED_POLICY_DETAIL,
  FETCH_INSURED_POLICY_DETAIL_SUCCESS,
  FETCH_INSURED_POLICY_DETAIL_FAILURE,
  FETCH_INSURED_ACCESS_LAST_UPDATED,
  FETCH_INSURED_ACCESS_LAST_UPDATED_SUCCESS,
  FETCH_INSURED_ACCESS_LAST_UPDATED_FAILURE,
} from '../actions/insuredAccessAction';
import uuidv4 from 'uuid/v4';
import { putCustState, fetchCustState } from '../../../actions/userActions';
import moment from 'moment';

export function* fetchInsuredPolicyList() {
  try {
    // const res = {
    //   status: 200,
    //   json: () => require('../mock/insuredAccessPolicyList.json'),
    // };
    const insuredPolicyListApiUrl = yield select(getInsuredPolicyListApiUrl);
    const res = yield call(
      myAxaFetchWithToken,
      insuredPolicyListApiUrl,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-axahk-msgid': uuidv4(),
        },
      },
      undefined,
      undefined,
      0,
    );
    const data = yield res.json();
    const response = data || [];

    yield put({
      type: FETCH_INSURED_POLICY_LIST_SUCCESS,
      policyList: response.sort((first: any, second: any) => {
        if (first.policy.policyName.en.startsWith('AXA WiseGuard Pro')) {
          return -1;
        }
        if (
          first.policyRiders.find((item: any) =>
            item.planName.en.startsWith('AXA WiseGuard Pro'),
          )
        ) {
          return -1;
        }
        return 0;
      }),
    });
    return response;
  } catch (error) {
    yield put({
      type: FETCH_INSURED_POLICY_LIST_FAILURE,
    });
    yield put(showErrorModal());
  }
}

export function* updateInsuredAccess(action: any) {
  const { policyNumber, insuredAccessFlag, callback, custKey } = action;

  try {
    // const res = {
    //   status: 200,
    //   json: () => require('../mock/updateInsuredAccessResponse.json'),
    // };
    const insuredAccessApiUrl = yield select(getInsuredAccessApiUrl);
    const res = yield call(
      myAxaFetchWithToken,
      insuredAccessApiUrl,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-axahk-msgid': uuidv4(),
          Accept: 'application/json',
        },
        body: JSON.stringify({
          recordCustomerProfilesAccessRequest: {
            policyNumber: policyNumber,
            insurerAccessFlag: insuredAccessFlag,
          },
        }),
      },
      undefined,
      undefined,
      0,
    );
    const data = yield res.json();
    const response = data.response || {};

    if (response.reasonCode === '200') {
      // Record last updated time by policy
      const resCustState = yield fetchCustState(custKey, 'emma');
      const accessObj = resCustState ? JSON.parse(resCustState) : {};
      accessObj[policyNumber] = moment().format();

      yield putCustState(custKey, JSON.stringify(accessObj), 'emma');

      yield put({
        type: UPDATE_INSURED_ACCESS_SUCCESS,
        policyNumber: policyNumber,
        accessCustState: accessObj,
        insuredAccessFlag,
      });
    } else {
      yield put({
        type: UPDATE_INSURED_ACCESS_FAILURE,
        error: true,
      });
    }

    callback();
  } catch (error) {
    yield put({
      type: UPDATE_INSURED_ACCESS_FAILURE,
      error: true,
    });

    callback();
  }
}

export function* fetchInsuredPolicyDetail(action: any) {
  try {
    // const res = {
    //   status: 200,
    //   json: () => require('../mock/insuredAccessPolicyDetail.json'),
    // };
    const insuredPolicyDetailApiUrl = yield select(
      getInsuredPolicyDetailApiUrl,
    );
    const url = `${insuredPolicyDetailApiUrl}/${action.policyNumber}?entityCode=${action.entityCode}&featureName=insuredaccess`;
    const res = yield call(
      myAxaFetchWithToken,
      url,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-axahk-msgid': uuidv4(),
        },
      },
      undefined,
      undefined,
      0,
      10,
    );
    const data = yield res.json();
    const response = data.retrievePolicyDetailsResponse || [];
    const { policy } = response;

    yield put({
      type: FETCH_INSURED_POLICY_DETAIL_SUCCESS,
      policyNumber: action.policyNumber,
      policy,
    });
    return response;
  } catch (error) {
    yield put({
      type: FETCH_INSURED_POLICY_DETAIL_FAILURE,
      policyNumber: action.policyNumber,
      error: true,
    });
  }
}

export function* fetchInsuredAccessLastUpdated(action: any) {
  const { custKey, destination } = action;

  try {
    // Record last updated time by policy
    const resCustState = yield fetchCustState(custKey, 'emma');
    const accessCustState = resCustState ? JSON.parse(resCustState) : {};

    yield put({
      type: FETCH_INSURED_ACCESS_LAST_UPDATED_SUCCESS,
      accessCustState,
      destination,
    });
  } catch (error) {
    yield put({
      type: FETCH_INSURED_ACCESS_LAST_UPDATED_FAILURE,
    });
  }
}

function* insuredAccessSaga() {
  yield takeLatest(FETCH_INSURED_POLICY_LIST, fetchInsuredPolicyList);
  yield takeLatest(UPDATE_INSURED_ACCESS, updateInsuredAccess);
  yield takeEvery(FETCH_INSURED_POLICY_DETAIL, fetchInsuredPolicyDetail);
  yield takeEvery(
    FETCH_INSURED_ACCESS_LAST_UPDATED,
    fetchInsuredAccessLastUpdated,
  );
}

export default insuredAccessSaga;
